import React, { useEffect } from 'react'
import './style.css'
import { Col, Container, Row, Card } from 'react-bootstrap'
import Navigation from '../../../components/navigation/Navigation'
import Banner from '../../../components/banner/banner'
import { APIINTEGRATION } from '../../../assets/images'
import SEO from '../../../components/seo/SEO'
import MultiListCard from './multi-list-card/MultiListCard'
import Footer from '../../../components/footer/Footer'

const PrivacyAndDataHandling = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const privacyFeatures = [
        {
            title: "PII Redaction",
            description: "Automatically identify and redact personally identifiable information to protect user privacy while maintaining data utility."
        },
        {
            title: "Retention Control",
            description: "Flexible data retention policies that allow you to define how long different types of data are stored based on your requirements."
        },
        {
            title: "Right to Erasure",
            description: "Complete data deletion capabilities ensuring compliance with privacy regulations and user rights to be forgotten."
        },
        {
            title: "Audit Logs",
            description: "Comprehensive logging of all data access and processing activities for transparency and compliance verification."
        },
        {
            title: "Data Export",
            description: "Seamless data portability features allowing users to export their data in standard formats when needed."
        }
    ]

    return (
        <>
            <SEO
              title="Privacy & Data Handling"
              description="Triumphal follows strict privacy and data handling practices, ensuring client and end-user data is managed responsibly and securely."
              path="/trust/privacy-and-data-handling"
              keywords="data privacy, data handling, enterprise data protection"
            />
            <Navigation />
            <Banner title="Privacy & Data Handling" bg={APIINTEGRATION} />

            <section className='api_intergration_section'>
                <Container className='mt-75 mb-75'>
                    <div>
                        <Row>
                            <Col lg={11}>
                                <div className='api_intergration_section_title'>
                                    <h3>
                                        Privacy by design purpose limited processing, minimal data collection, and full control over retention and deletion.
                                    </h3>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className='mt-75 api_intergration_cards'>
                        <Row>
                            {privacyFeatures.map((feature, index) => (
                                <Col lg={4} md={6} key={index} className="mb-4">
                                    <Card className='multi_list_card'>
                                    <div className="privacy-feature-card">
                                        <h4>{feature.title}</h4>
                                        <p>{feature.description}</p>
                                    </div>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>

                       <div className='api_intergration_cards'>
                <MultiListCard  />
            </div>
                </Container>
            </section>

            <Footer />
        </>
    )
}

export default PrivacyAndDataHandling